export default __webpack_public_path__ + "static/media/svg-5.5394e075.svg";